import CategoriasLocalService from './tareasperiodicas/edit-categorias/categorias-local.service';
import EditCategoriasCtrl from './tareasperiodicas/edit-categorias/edit-categorias.controller';
import EditCategoriasDirective from './tareasperiodicas/edit-categorias/edit-categorias.directive';
import CategoriaActionsService from './tareasperiodicas/categorias/categoria-actions.service';
import DialogEditCategoriaCtrl from './tareasperiodicas/categorias/dialog-edit/dialog-edit-categoria.controller';
import OrdenRestService from './ordenes/ordenRestService';
import OrdenesGridCtrl2 from './ordenes/ordenesGridCtrl';
import OrdenActionsService from './ordenes/ordenActionsService';
import DialogOrdenesAddCtrl from './ordenes/add/dialogOrdenesAddCtrl';
import DialogOrdenesAddItemsCtrl from './ordenes/add-items/dialogOrdenesAddItemsCtrl';
import UnidadGestionActionsService from './mantenimiento/unidadesGestion/unidadGestionActionsService';
import DialogAddEntUniGesCtrl from './mantenimiento/unidadesGestion/add-ent/dialogAddEntUniGesCtrl';
import DialogAddTipoUniGesCtrl from './mantenimiento/unidadesGestion/add-tipo/dialogAddTipoUniGesCtrl';
import DialogAddUserUniGesCtrl from './mantenimiento/unidadesGestion/add-user/dialogAddUserUniGesCtrl';
import TiposOrdenesActionsService from './mantenimiento/tipos-ordenes/tiposOrdenesActionsService'
import DialogTiposOrdenesEditCtrl from './mantenimiento/tipos-ordenes/edit/dialogTiposOrdenesEditCtrl';
import ColumnasUsuariosCtrl from './mantenimiento/columnas-usuarios/ColumnasUsuariosCtrl';
import ColumnasEditDialogCtrl from './mantenimiento/columnas-usuarios/edit/ColumnasEditDialogCtrl';
import StringUtils from "./common/factories/stringUtils";
import FormatDateFilter from "./common/filters/formatDateFilter";
import LangFilter from "./common/filters/langFilter";
import LowerCaseFilter from "./common/filters/lowerCaseFilter";
import EntidadService from "./common/services/entidadApiService";
import CapitalizeFilter from "./common/filters/capitalizeFilter";
import SigoUIModule from "./sigo-ui/sigo-ui.module";
import CamposExtraModule from "./campos-extra/camposExtra.module";
import EnviosEntidadesModule from "./envios-entidades/enviosEntidades.module";
import ngResourceModuleName from 'angular-resource';
import uiRouterModuleName from 'angular-ui-router';
import ColumnasUsuariosDirective from "./mantenimiento/columnas-usuarios/columnas-usuarios.directive";
import TareasFinalizarDialogCtrl from "./tareas/finalizar/tareasFinalizarDialogCtrl";
import InspecAddEditDialogCtrl from "./incidencias/inspecciones/InspecAddEditDialogCtrl";
import InspeccionesDetallesCtrl from "./incidencias/inspecciones/inspeccionesDetallesCtrl";
import InspeccionesDetallesDirectiva from "./incidencias/inspecciones/inspeccionesDetallesDirectiva";
import InspeccionIncidenciaService from "./incidencias/inspecciones/inspeccionesService";
import InspecFinDialogCtrl from "./incidencias/inspecciones/InspecFinDialogCtrl";
require('angucomplete-alt');
const angular = require('angular');


/**
 * Modulo principal de angular. Todos deben inyectar este, para poner en este la configuración global.
 */
const AppModule = angular
    .module('app', [uiRouterModuleName, SigoUIModule.name, "angucomplete-alt", ngResourceModuleName,
        CamposExtraModule.name, EnviosEntidadesModule.name])
    .config(ConfigHttpProvider)
    .config(ConfigLangProvider)

    .factory('CategoriasLocal', CategoriasLocalService)
    .controller('EditCategoriasCtrl', EditCategoriasCtrl)
    .directive('editCategorias', EditCategoriasDirective)
    .service('CategoriaActionsService', CategoriaActionsService)
    .controller('DialogEditCategoriaCtrl', DialogEditCategoriaCtrl)

    .service('Orden', OrdenRestService)
    .controller('OrdenesGridCtrl2', OrdenesGridCtrl2)
    .service('OrdenActionsService', OrdenActionsService)
    .controller('DialogOrdenesAddCtrl', DialogOrdenesAddCtrl)
    .controller('DialogOrdenesAddItemsCtrl', DialogOrdenesAddItemsCtrl)

    .service('UnidadGestionActionsService', UnidadGestionActionsService)
    .controller('DialogAddEntUniGesCtrl', DialogAddEntUniGesCtrl)
    .controller('DialogAddTipoUniGesCtrl', DialogAddTipoUniGesCtrl)
    .controller('DialogAddUserUniGesCtrl', DialogAddUserUniGesCtrl)

    .service('TiposOrdenesActionsService', TiposOrdenesActionsService)
    .controller('DialogTiposOrdenesEditCtrl', DialogTiposOrdenesEditCtrl)

    .controller('ColumnasUsuariosCtrl', ColumnasUsuariosCtrl)
    .directive('columnasUsuarios', ColumnasUsuariosDirective)
    .controller('ColumnasEditDialogCtrl', ColumnasEditDialogCtrl)

    .factory('stringUtils', StringUtils)
    .filter('capitalize', CapitalizeFilter)
    .filter("formatDate", FormatDateFilter)
    .filter('lang', LangFilter)
    .filter('lowerCase', LowerCaseFilter)
    .factory('Entidad', EntidadService)

    .controller('TareasFinalizarDialogCtrl', TareasFinalizarDialogCtrl)

    .controller('InspecAddEditDialogCtrl', InspecAddEditDialogCtrl)
    .controller('InspeccionesDetallesCtrl', InspeccionesDetallesCtrl)
    .directive('inspecciones', InspeccionesDetallesDirectiva)
    .service('InspeccionIncidencia', InspeccionIncidenciaService)
    .controller('InspecFinDialogCtrl', InspecFinDialogCtrl)
;

var HEADER_API_KEY = 'X-Api-Key';
var HEADER_API_TOKEN = 'X-Auth-Token';
var HEADER_WEB_VERSION = 'X-Web-Version';

ConfigLogProvider.$inject = ['$logProvider'];

function ConfigLogProvider($logProvider) {
    $logProvider.debugEnabled(true);
}

ConfigLangProvider.$inject = ["langProvider"];

function ConfigLangProvider(langProvider) {
    langProvider.setLang(Lang.locale());
}

ConfigHttpProvider.$inject = ['$httpProvider'];

function ConfigHttpProvider($httpProvider) {

    var excepcionesIgnoradas = ['TipoNoDesactivableException'];

    $httpProvider.interceptors.push(['$q', function ($q) {
        return {
            request: function (httpConfig) {
                if (typeof httpConfig.headers[HEADER_API_KEY] == 'undefined')
                    httpConfig.headers[HEADER_API_KEY] = Sigo.var.apiKey;

                httpConfig.headers[HEADER_API_TOKEN] = Sigo.var.apiToken;
                httpConfig.headers[HEADER_WEB_VERSION] = null;
                httpConfig.headers['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');

                return httpConfig;
            },
            responseError: function (response) {

                if (response.data != null) {
                    var respuesta = response.data;
                    var contieneExcepcion = typeof respuesta.error != 'undefined' && typeof respuesta.error.type != 'undefined';
                    var mostramosMensaje = contieneExcepcion && excepcionesIgnoradas.indexOf(respuesta.error.type) == -1;

                    if (mostramosMensaje) {
                        var mensajes = null;
                        if (contieneExcepcion) {
                            mensajes = [Lang.get(respuesta.error.message)];
                        } else if (typeof respuesta.messages != 'undefined') {
                            mensajes = [respuesta.messages];
                        }

                        if (mensajes != null) Sigo.UI.Messages.open(mensajes, 0);
                    }
                }

                return $q.reject(response);
            }
        };
    }]);

}

export default AppModule;